import * as React from "react";
const SvgFiRrTentArrowDownToLine = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-tent-arrow-down-to-line_svg__a)">
      <path
        fill="#062147"
        d="M.27 5.319a1 1 0 0 1 1.413-.052L4 7.42V1a1 1 0 1 1 2 0v6.421l2.317-2.154a1 1 0 1 1 1.361 1.465L7.067 9.158a2.9 2.9 0 0 1-2.058.844 2.97 2.97 0 0 1-2.104-.869L.321 6.732a1 1 0 0 1-.052-1.413zm23.059 16.705A4.26 4.26 0 0 1 19.725 24H1a1 1 0 1 1 0-2h3.656a4.24 4.24 0 0 1-.254-4.064c.022-.048 5.846-8.668 5.871-8.699C11.477 7.845 12.329 7 13.998 7c1.436 0 2.673.756 3.782 2.31 0 0 5.795 8.578 5.817 8.625a4.24 4.24 0 0 1-.27 4.089zM16.477 22l-1.975-3.644C14.348 18.029 14.101 18 14 18a.51.51 0 0 0-.475.302L11.524 22zm5.339-3.154-5.677-8.395C15.222 9.167 14.513 9 13.999 9c-.691 0-1.025.178-2.173 1.5l-5.64 8.345a2.22 2.22 0 0 0 .173 2.104A2.24 2.24 0 0 0 8.277 22h.973l2.49-4.597C12.131 16.558 13.008 16 14 16s1.869.559 2.287 1.458L18.751 22h.974c.793 0 1.492-.383 1.918-1.051a2.22 2.22 0 0 0 .173-2.104z"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-tent-arrow-down-to-line_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrTentArrowDownToLine;
